/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';

/**
 * 
 * @export
 * @interface UpdateUserTypeBody
 */
export interface UpdateUserTypeBody {
    /**
     * 
     * @type {UserType}
     * @memberof UpdateUserTypeBody
     */
    type: UserType;
}



/**
 * Check if a given object implements the UpdateUserTypeBody interface.
 */
export function instanceOfUpdateUserTypeBody(value: object): value is UpdateUserTypeBody {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function UpdateUserTypeBodyFromJSON(json: any): UpdateUserTypeBody {
    return UpdateUserTypeBodyFromJSONTyped(json, false);
}

export function UpdateUserTypeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserTypeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'type': UserTypeFromJSON(json['type']),
    };
}

export function UpdateUserTypeBodyToJSON(json: any): UpdateUserTypeBody {
    return UpdateUserTypeBodyToJSONTyped(json, false);
}

export function UpdateUserTypeBodyToJSONTyped(value?: UpdateUserTypeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': UserTypeToJSON(value['type']),
    };
}

